import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private httpClient: HttpClient, @Inject('apiEndPoint') private apiEndPoint: string,  @Inject('fileServerUrl') private fileServerUrl: string,) { }
  getAllUsers(params) {
    return this.httpClient.post(this.apiEndPoint + '/users/_search?size=1000', params);
  }
  getAllProfiles() {
    let params = {
      "query": {},
      sort: [{ "_kuzzle_info.createdAt": "asc" }]
    }
    return this.httpClient.post(this.apiEndPoint + '/profiles/_search?size=1000', params);

  }
  getAllRoles() {
    return this.httpClient.get(this.apiEndPoint + '/gwdevice/configparam/_search?size=1000');

  }
  createUser(body, userName) {
    return this.httpClient.post(this.apiEndPoint + '/users/' + userName + '/_create', body);

  }
  createUserByAdmin(body, userName) {
    return this.httpClient.post(this.fileServerUrl + '/users/_create', body);

  }
  updateUser(body, userName) {
    return this.httpClient.put(this.apiEndPoint + '/users/' + userName + '/_update', body);

  }
  deleteUser(userName) {
    return this.httpClient.delete(this.apiEndPoint + '/users/' + userName);

  }
  updatePassword(password: any) {
    let body = {
      "password": password
    }
   
    return this.httpClient.put(this.fileServerUrl + '/_me/credentials/_update', body);

  }

  getStrategyOfUser(id){
    return this.httpClient.get(this.apiEndPoint + '/users/'+id+'/_strategies');
  }
updateUserPassw0rdByAdmin(id,password){
  let body = {
    "username": id,
    "password": password
  }
  return this.httpClient.put(this.fileServerUrl+ '/credentials/_update',body)
}

  getCurrentUser() {
        return this.httpClient.get(`${this.apiEndPoint}/_me`)
    }

}



